var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamoDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 96,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5294cf",
    d: "M90.45 76.024h.668l10.897-5.48.18-.258v-43.73l-.18-.26-10.897-5.474h-.676l.008 55.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f5b98",
    d: "M76.27 76.024h-.677l-10.888-5.48-.22-.382-.112-43.384.333-.482 10.888-5.474h.685l-.008 55.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d72b8",
    d: "M75.61 20.823h15.496v55.2H75.61z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a476f",
    d: "M107.72 47.183l-.368-.082-5.258-.493-.078.04-10.907-.44H75.61l-10.907.44v-8.362l-.01.006.01-.024 10.907-2.54h15.497l10.907 2.54 4 2.143v-1.378l1.695-.186-.175-.344-5.365-3.857-.163.053L91.108 31.3H75.61l-10.907 3.398v-8.4L59 33.016v5.868l.044-.032 1.65.18v1.406L59 41.35v5.838l.044-.005 1.65.024v2.45l-1.424.02-.27-.026v5.84l1.695.916v1.422l-1.624.18-.07-.054v5.867l5.704 6.72v-8.4l10.907 3.398h15.497l10.94-3.408.145.064 5.295-3.8.232-.38-1.695-.188V56.44l-.222-.09-3.624 1.964-.13.276-10.94 2.526v.003H75.61v-.003L64.704 58.58v-8.393l10.907.437v.01h15.497l10.907-.448.248.115 5.096-.44.36-.177-1.695-.024v-2.45l1.695-.024"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.016 62.145v8.4l5.704-6.72v-5.828l-5.67 4.138-.033.01m0-3.548l.033-.008 5.67-3.067v-5.864l-5.704.528v8.41m.033-20.323l-.033-.008v8.38l5.704.536v-5.86l-5.67-3.047m0-3.544l5.67 4.115v-5.83l-5.704-6.72v8.4l.033.01v.02",
    fill: "#2d72b8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamoDb);
export default __webpack_public_path__ + "static/media/DynamoDB.e2fd0af3f9a3706df8c94498900fcc71.svg";
export { ForwardRef as ReactComponent };